<template>
    <div>
      <slide-over-panel v-model:show="showNotifications">
        <template #title>Alarm Notification Log</template>
        <template #content>
          <slot name="notifications">
          </slot>
        </template>
      </slide-over-panel>
      <form :action="formLink" method="POST">
          <input type="hidden" name="_token" :value="csrf" />
        <div    v-if="canUpdateAlarms"
                class="flex justify-center">
          <div class="flex flex-wrap md:w-full lg:w-2/3 pt-2">
            <!--            Tailwind UI -> Navigation -> Tabs -> Full-width tabs with Underline-->
            <div class="w-full">
              <div class="sm:hidden pb-4 sm:pb-0">
                <select @change="showViaSelect" aria-label="Selected tab" class="w-full bg-white block focus:ring-blue-500 focus:border-blue-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                  <option disabled selected>Select an action</option>
                  <option value="comment" :selected="commentOnly || comment">Comment</option>
                  <option value="snooze" :selected="snooze">Snooze</option>
                  <option value="resolve" :selected="resolve">Resolve</option>
                </select>
              </div>
              <div class="hidden sm:block">
                <div class="border-b border-gray-200">
                  <nav class="-mb-px flex">
                    <a
                      @click="showComment"
                      v-bind:class="{ 'text-blue-600 border-blue-500 focus:outline-none focus:text-blue-800 focus:border-blue-700': comment,
                               'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300': !comment }"
                      class="w-1/3 py-4 px-1 text-center border-b-2 font-medium text-lg leading-5 cursor-pointer">
                      Comment
                    </a>
                    <a
                      @click="showSnooze"
                      v-bind:class="{ 'text-blue-600 border-blue-500 focus:outline-none focus:text-blue-800 focus:border-blue-700': snooze,
                               'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300': !snooze }"
                      class="w-1/3 py-4 px-1 text-center border-b-2 font-medium text-lg leading-5 cursor-pointer">
                      Snooze
                    </a>
                    <a
                      @click="showResolve"
                      v-bind:class="{ 'w-1/3 py-4 px-1 text-center border-b-2 font-medium text-lg leading-5 text-blue-600 border-blue-500 focus:outline-none focus:text-blue-800 focus:border-blue-700': resolve,
                               'w-1/3 py-4 px-1 text-center border-b-2 font-medium text-lg leading-5 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300': !resolve }"
                      class="w-1/3 py-4 px-1 text-center border-b-2 font-medium text-lg leading-5 cursor-pointer">
                      Resolve
                    </a>
                  </nav>
                </div>
              </div>
            </div>
            <alarm-address-comment v-if="comment"
                                   :send-event-only="sendEventOnly"
                                   @adding-comment="$emit('adding-comment', $event)"

            ></alarm-address-comment>
            <alarm-address-snooze   v-if="snooze && !commentOnly" :send-event-only="sendEventOnly"
                                    :timezone="timezone"
                                    @snoozing-alarm="$emit('snoozing-alarm', $event)"
            ></alarm-address-snooze>
            <alarm-address-resolve  v-if="resolve && !commentOnly"
                                    :is-mass-resolving = isMassResolving
                                    :send-event-only="sendEventOnly"
                                    @resolving-alarm="$emit('resolving-alarm', $event)"
            ></alarm-address-resolve>
            <div v-if="!snooze && !comment && !resolve"
                 class="w-full bg-white shadow overflow-hidden sm:rounded-lg hidden sm:block">
              <div class="px-4 py-8">
                <p class="text-gray-400 text-center text-center text-4xl">
                  select an action above
                </p>
              </div>
            </div>
            <div v-if="commentOnly && (resolve || snooze)"
                 class="w-full bg-white shadow overflow-hidden rounded-lg block">
              <div class="px-4 py-8">
                <p class="text-gray-400 text-center text-center text-xl sm:text-4xl">
                  This alarm has been resolved; you may only leave comments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="flex flex-wrap mt-8 -mb-12 justify-center">
        <button-blue-secondary @click="showNotifications = !showNotifications" class="w-full md:w-1/4">
          Show Notification Log
        </button-blue-secondary>
      </div>

      <alarm-comments :comments='comments'></alarm-comments>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import AlarmAddressSnooze from "./alarmAddressSnooze";
import AlarmAddressComment from "./alarmAddressComment";
import AlarmAddressResolve from "./alarmAddressResolve";
import AlarmComments from "@/components/alarmComments";
import SlideOverPanel from "@/components/elements/SlideOverPanel.vue";
import SonicuButton from "@/components/elements/buttons/SonicuButton.vue";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary.vue";

    export default {
        name: "alarmAddress",
        components: {
          ButtonBlueSecondary,
          SonicuButton,
          AlarmAddressSnooze, AlarmAddressComment, AlarmAddressResolve, AlarmComments, SlideOverPanel},
        mixins: [SonicuCoreMixin],
        props: {
            serverComments: {
                type: Array,
                default: () => [],
            },
            commentOnly: {
                type: Boolean,
                default: false,
            },
            timezone: String,
            sendEventOnly: {
                type: Boolean,
                default: false,
            },
            isMassResolving: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                snooze: false,
                comment: this.commentOnly,
                comments: this.serverComments,
                resolve: false,
                showNotifications: false,
            }
        },
        mounted() {
        },
        methods: {
            showComment(event) {
                this.resolve = false;
                this.snooze = false;
                this.comment = true;
            },
            showSnooze(event) {
                this.comment = false;
                this.resolve = false;
                this.snooze = true;
            },
            showResolve(event) {
                this.comment = false;
                this.snooze = false;
                this.resolve = true;
            },
            showViaSelect(event) {
                if (event.target.value === 'comment') {
                    this.showComment()
                } else if (event.target.value === 'snooze') {
                    this.showSnooze()
                } else if (event.target.value === 'resolve') {
                    this.showResolve()
                } else {
                    this.comment = false;
                    this.snooze = false;
                    this.resolve = false;
                }
            },
            canUpdateAlarms() {
                return this.permissions.can('update_alarms')
            },
        },
        computed: {
            formLink() {
                return window.location.pathname
            },
        }
    }
</script>

<style scoped>

</style>